export const DOCS_URL = 'https://docs.latlens.com';

export const PAGE_TITLES: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/usage': 'Usage',
  '/trips': 'Your trips',
  '/keys': 'API keys',
  '/team': 'Team',
  '/team/members': 'Team members',
  '/team/billing': 'Team billing',
  '/team/usage': 'Team usage',
  '/roles': 'Roles',
  '/billing': 'Billing',
  '/integrations': 'Integrations',
  '/startups/apply': 'Startup programme',
  '/notifications': 'Notifications',
  '/settings': 'Settings',
  '/admin/analytics': 'Platform analytics',
  '/admin/traffic': 'Traffic data',
  '/platform/health': 'Platform health',
  '/admin/services': 'Services',
  '/support/users': 'Users',
  '/admin/credits': 'Credits',
  '/admin/coupons': 'Coupons',
  '/admin/pricing': 'Pricing',
  '/programme': 'Applications',
  '/admin/startups': 'Programme settings',
  '/admin/audit-logs': 'Audit logs',
  '/platform/admins': 'Platform admins',
  '/admin/email-settings': 'Email settings',
  '/admin/privacy': 'Privacy by country',
};

/** The menu group a page sits in, shown before its title in the top bar. Same groups as the sidebar. */
export const PAGE_SECTIONS: Record<string, string> = {
  '/admin/analytics': 'Platform', '/admin/traffic': 'Platform', '/platform/health': 'Platform', '/admin/services': 'Platform',
  '/support/users': 'Customers', '/admin/credits': 'Customers', '/admin/coupons': 'Customers', '/admin/pricing': 'Customers',
  '/programme': 'Programme review', '/admin/startups': 'Programme review',
  '/admin/audit-logs': 'Security', '/platform/admins': 'Security', '/admin/email-settings': 'Security', '/admin/privacy': 'Security',
};
